import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { ApiError } from '@/shared/services/api-error';

/**
 * Cria o cliente de consultas com as politicas padrao do projeto.
 *
 * Nao repete requisicao que falhou por regra de negocio: `401`, `403`, `404` e
 * `422` sao respostas definitivas, e insistir nelas so gasta tempo do usuario e
 * ruido no log.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            const definitive = [400, 401, 403, 404, 409, 422];
            if (error.status !== null && definitive.includes(error.status)) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}

export function QueryProvider({ children }: { children: ReactNode }) {
  // `useState` com inicializador: o cliente precisa sobreviver a re-render, mas
  // nao pode ser um singleton de modulo (vazaria cache entre testes).
  const [client] = useState(createQueryClient);
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
